import React, { useState, useEffect } from "react";
import styled from "@emotion/styled";
import { SmallText } from "../../../components/core/Utility";
import "primeicons/primeicons.css";

const rowsDefault = [{ row: "" }];

const TableContainer = styled.div`
  font-family: Verizonn-NHG-eTx, Helvetica, Arial, sans-serif;
  border-radius: 10px;
  width: 100%;
  overflow-x: auto;
  border-bottom: none;
`;

const StyledTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;
  font-size: 0.85em;
  margin-bottom: 0;
  border-bottom: none;

  th {
    background-color: #f8f9fa;
    padding: 2px 8px;
    text-align: left;
    font-weight: bold;
    border: none;
  }

  td {
    padding: 2px 8px;
    vertical-align: top;
    border-bottom: none;
    line-height: 1.1;
  }

  tr.last-in-group td {
    padding-bottom: 20px !important;
    border-bottom: none;
  }

  tr.last-row td {
    padding-bottom: 10px !important;
  }

  tr {
    margin: 0;
    height: auto;
    min-height: 0;
  }

  * {
    margin: 0;
    padding: 0;
  }

  margin-bottom: 10px;
`;

const subCategoryBorder = {
  borderRight: "1px solid #D8DADA",
};

export const InstallationSummaryGrid = ({ noDataMessage = "No data to display", rows = { rowsDefault } }) => {
  const [sortConfig, setSortConfig] = useState({
    key: "type",
    direction: "ascending",
  });
  const [sortedRows, setSortedRows] = useState(rows);

  useEffect(() => {
    setSortedRows(rows);
  }, [rows]);

  const handleSort = (key) => {
    const direction = sortConfig.key === key && sortConfig.direction === "ascending" ? "descending" : "ascending";

    setSortConfig({ key, direction });
  };

  if (!sortedRows.length) {
    return <SmallText>{noDataMessage}</SmallText>;
  }

  return (
    <TableContainer>
      <StyledTable>
        <thead>
          <tr>
            <th style={{ width: "9%" }}>
              <SmallText bold>Bundle Id</SmallText>
            </th>
            <th style={{ width: "17%" }}>
              <SmallText bold>Subscription Name</SmallText>
            </th>
            <th style={{ width: "14%" }}>
              <SmallText bold>Tech Ref ID</SmallText>
            </th>
            <th style={{ width: "9%" }}>
              <SmallText bold>Order Quantity</SmallText>
            </th>
            <th style={{ width: "6%" }}>
              <SmallText bold>Fallout</SmallText>
            </th>
            <th style={{ width: "17%" }}>
              <SmallText bold>Service Name</SmallText>
            </th>
            <th style={{ width: "9%" }}>
              <SmallText bold>Not Scheduled</SmallText>
            </th>
            <th style={{ width: "7%" }}>
              <SmallText bold>Scheduled</SmallText>
            </th>
            <th style={{ width: "6%" }}>
              <SmallText bold>Installed</SmallText>
            </th>
            <th style={{ width: "6%" }}>
              <SmallText bold>Past Due</SmallText>
            </th>
          </tr>
        </thead>
        <tbody>
          {sortedRows.map((vehicle, vehicleIndex) => {
            const isEvenVehicle = vehicleIndex % 2 === 1;
            const groupBackgroundColor = isEvenVehicle ? "rgb(240, 240, 240)" : "white";
            const isLastRow = vehicleIndex === sortedRows.length - 1;

            if (!vehicle.summaryLines || !vehicle.summaryLines.length) {
              return (
                <tr
                  key={`${vehicle.bundleId}-empty`}
                  style={{ backgroundColor: groupBackgroundColor }}
                  className={`vehicle-row ${isLastRow ? "last-row" : ""}`}
                >
                  <td>
                    <SmallText>{vehicle.bundleId}</SmallText>
                  </td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
              );
            }

            return vehicle.summaryLines.map((material, materialIndex) => {
              const isFirstMaterial = materialIndex === 0;
              const isLastMaterial = materialIndex === vehicle.summaryLines.length - 1;
              const isLastInGroup = isLastMaterial;

              return (
                <tr
                  key={`${vehicle.bundleId}-${material.subscriptionId}-${materialIndex}`}
                  style={{ backgroundColor: groupBackgroundColor }}
                  className={`
                    ${materialIndex === 0 ? "vehicle-row" : ""}
                    ${isLastInGroup && !isLastRow ? "last-in-group" : ""}
                    ${isLastRow && isLastMaterial ? "last-row" : ""}
                  `}
                >
                  {isFirstMaterial ? (
                    <td rowSpan={vehicle.summaryLines.length}>
                      <SmallText>{vehicle.bundleId}</SmallText>
                    </td>
                  ) : null}
                  <td>
                    <SmallText>
                      {material.subscription} ({material.subscriptionId})
                    </SmallText>
                  </td>
                  <td>
                    <SmallText>{material.techRefId || "--"}</SmallText>
                  </td>
                  <td>
                    <SmallText>{material.ordered}</SmallText>
                  </td>
                  <td>
                    <SmallText>{material.fallout}</SmallText>
                  </td>
                  <td style={subCategoryBorder}>
                    <SmallText>
                      {material.serviceName} ({material.serviceId})
                    </SmallText>
                  </td>
                  <td>
                    <SmallText>{material.notScheduled}</SmallText>
                  </td>
                  <td>
                    <SmallText>{material.scheduled}</SmallText>
                  </td>
                  <td>
                    <SmallText>{material.installed}</SmallText>
                  </td>
                  <td>
                    <SmallText>{material.pastDue}</SmallText>
                  </td>
                </tr>
              );
            });
          })}
        </tbody>
      </StyledTable>
    </TableContainer>
  );
};
